"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _tabButtonGroup = _interopRequireDefault(require("./tab-button-group.css"));

var _tabButton = _interopRequireDefault(require("./tab-button"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TabButtonGroup = function TabButtonGroup(_ref) {
  var className = _ref.className,
      name = _ref.name,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      tabs = _ref.tabs,
      buttonLabelFormatter = _ref.buttonLabelFormatter;

  var _useState = (0, _react.useState)(defaultValue),
      selectedValue = _useState[0],
      setSelectedValue = _useState[1];

  (0, _react.useEffect)(function () {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  var handleChange = function handleChange(value, tabIndex) {
    if (selectedValue !== value) {
      setSelectedValue(value);
      onChange({
        value: value,
        name: name,
        tabIndex: tabIndex,
        tabs: tabs
      });
    }
  };

  var isSelected = function isSelected(tab) {
    if (selectedValue === undefined) return tab["default"] === true;
    return selectedValue === tab.value;
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_tabButtonGroup["default"].tabButtonGroup, className)
  }, tabs.map(function (tab, index) {
    return /*#__PURE__*/_react["default"].createElement(_tabButton["default"], {
      key: tab.value,
      value: tab.value,
      index: index,
      selected: isSelected(tab),
      onClick: handleChange,
      buttonLabelFormatter: buttonLabelFormatter
    });
  }));
};

var _default = TabButtonGroup;
exports["default"] = _default;